var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabTop1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5V5H11C9.11438 5 8.17157 5 7.58579 5.58579C7 6.17157 7 7.11438 7 9V25.75C7 27.6356 7 28.5784 7.58579 29.1642C8.17157 29.75 9.11438 29.75 11 29.75H22.25C24.1356 29.75 25.0784 29.75 25.6642 29.1642C26.25 28.5784 26.25 27.6356 26.25 25.75V13.25H20.75C19.4536 13.25 18.8055 13.25 18.4027 12.8473C18 12.4445 18 11.7964 18 10.5Z",
    fill: "#7E869E",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2359 5H12.5C9.90728 5 8.61091 5 7.80546 5.80546C7 6.61091 7 7.90727 7 10.5V24.25C7 26.8427 7 28.1391 7.80546 28.9445C8.61091 29.75 9.90727 29.75 12.5 29.75H20.75C23.3427 29.75 24.6391 29.75 25.4445 28.9445C26.25 28.1391 26.25 26.8427 26.25 24.25V13.0141C26.25 12.4521 26.25 12.171 26.1453 11.9184C26.0407 11.6657 25.842 11.467 25.4445 11.0695L20.1805 5.80546C19.783 5.40804 19.5843 5.20933 19.3316 5.10467C19.079 5 18.7979 5 18.2359 5Z",
    stroke: "#222222",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.75L20.75 18.75",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.25L18 24.25",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5V10.5C18 11.7964 18 12.4445 18.4027 12.8473C18.8055 13.25 19.4536 13.25 20.75 13.25H26.25",
    stroke: "#222222",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabTop1);
export default __webpack_public_path__ + "static/media/tab-top-1.38ed5d32dbee26cab8f55cea80253ce9.svg";
export { ForwardRef as ReactComponent };